var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBD42"
    },
    d: "M33.052,356.136l-0.822,0.822l0,0L0.613,485.716c-1.77,7.209,0.355,14.819,5.604,20.068 l88.242-88.242L33.052,356.136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#30767A"
    },
    d: "M502.599,86.817L425.182,9.402c-12.536-12.536-32.86-12.536-45.396,0L311.18,78.008l-10.078,10.078 L32.23,356.957l0,0L0.613,485.716c-1.77,7.209,0.355,14.819,5.604,20.068c5.249,5.249,12.858,7.374,20.068,5.604l128.759-31.617l0,0 l268.873-268.873l10.078-10.078l68.606-68.606C515.135,119.677,515.135,99.353,502.599,86.817z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007066"
    },
    d: "M425.182,9.402c-12.536-12.536-32.86-12.536-45.396,0L311.18,78.008l-10.078,10.078L32.23,356.957 l0,0L0.613,485.716c-1.77,7.209,0.355,14.819,5.604,20.068L463.891,48.11L425.182,9.402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4AB6BF"
    },
    d: "M425.182,9.402c-12.536-12.536-32.86-12.536-45.396,0L311.18,78.008l-10.078,10.078L32.23,356.957 l0,0L0.613,485.716c-1.77,7.209,0.355,14.819,5.604,20.068L463.891,48.11L425.182,9.402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#940009"
    },
    d: "M466.265,168.547l36.334-36.334c12.536-12.536,12.536-32.86,0-45.396L425.182,9.402 c-12.536-12.536-32.86-12.536-45.396,0l-36.334,36.334L466.265,168.547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF0029"
    },
    d: "M463.891,48.11L425.182,9.402c-12.536-12.536-32.86-12.536-45.396,0l-36.334,36.334l61.407,61.407 L463.891,48.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DC4D"
    },
    d: "M33.052,356.136l-0.822,0.822l0,0L0.613,485.716c-1.77,7.209,0.355,14.819,5.604,20.068 c5.249,5.249,12.858,7.374,20.068,5.604l128.759-31.617l0,0l0.822-0.822L33.052,356.136z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.713,
    y: 90.415,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 566.3668 489.469)",
    style: {
      fill: "#FF9800"
    },
    width: 173.685,
    height: 74.042
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7DC4D"
    },
    points: "410.735,101.265 349.328,39.86 311.18,78.007 301.103,88.085 296.972,92.217  358.378,153.622 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D2B27"
    },
    d: "M11.138,442.855l-10.524,42.86c-1.77,7.209,0.355,14.819,5.604,20.068 c5.249,5.249,12.858,7.374,20.068,5.604l42.86-10.525L11.138,442.855z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#403E3B"
    },
    d: "M11.138,442.855l-10.524,42.86c-1.77,7.209,0.355,14.819,5.604,20.068l33.925-33.925L11.138,442.855z "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/edit-pencil.679b64882fd45d48fb5fc768d3ba2ca4.svg";
export { ForwardRef as ReactComponent };